import { Observable } from "rxjs";
import { WeekHours } from "../models/agreement.model";
import {
  ContractResourceModalData,
  CreateFakeResourcePayload,
  PfGeo,
} from "../models/contract-resource.model";
import { Discipline } from "../models/discipline.model";
import { ProfessionalFigure } from "../models/figure.model";
import { Geo } from "../models/geo.model";
import { Resource } from "../models/personnel.model";
import { Practice } from "../models/practice.model";

export abstract class HrRepository {
  abstract getAllProfessionalFigure(): Observable<ProfessionalFigure[]>;
  abstract getAllGeos(): Observable<Geo[]>;
  abstract getAllPractices(): Observable<Practice[]>;
  abstract getAllDisciplines(): Observable<Discipline[]>;
  abstract getWeekHoursByPracDisc(
    startDate: string,
    endDate: string,
    pracId: number,
    discId: number,
  ): Observable<WeekHours[]>;
  abstract getWeekHoursByPracDiscFPGeo(
    startDate: string,
    endDate: string,
    pracId: number,
    discId: number,
    professionalFigureId: string,
    geoId: string,
  ): Observable<WeekHours[]>;
  abstract getWeekHoursByPracDiscFPGeoRes(
    startDate: string,
    endDate: string,
    pracId: number,
    discId: number,
    professionalFigureId: string,
    geoId: string,
    resId: number,
  ): Observable<WeekHours[]>;

  abstract getAllActivePE(
    startDate: string,
    endDate: string,
  ): Observable<Resource[]>;

  abstract retrieveContractResourceModalData(
    startDate: string,
    endDate: string,
  ): Observable<ContractResourceModalData>;
  abstract createFakeResource(
    createFakeResourcePayload: CreateFakeResourcePayload,
  ): Observable<Resource>;
  abstract retrieveAllPfGeos(): Observable<PfGeo[]>;
  abstract retrieveFreezeCosts(agreementId: number): Observable<any>;
}
